import {where} from "firebase/firestore";
import {sumarPropiedadColeccionWheres} from "../../Servicios/BD/Contadores/sumarPropiedadColeccionWheres";

export const obtenerTotalAhorrado = async ({idBolsillo}) => {


    let wheres =
        [
            where('idBolsillo', '==', idBolsillo),
            where('estado', '==', 'Aceptado'),
            where('tipo', 'in', ['Deposito', 'Rendimiento']),
        ]

    let dox = await sumarPropiedadColeccionWheres({coleccion: 'movimientos', wheres: wheres, propiedad: 'valor'})

    let totalDepositos = 0
    if (dox.res) {
        totalDepositos = dox.data
    } else {
        totalDepositos = 0
    }

    let wheresRetiros =
        [
            where('idBolsillo', '==', idBolsillo),
            where('tipo', '==', 'Retiro'),
        ]

    let doxReti = await sumarPropiedadColeccionWheres({
        coleccion: 'movimientos',
        wheres: wheresRetiros,
        propiedad: 'valor'
    })

    let totalRetiros = 0
    if (doxReti.res) {
        totalRetiros = doxReti.data
    } else {
        totalRetiros = 0
    }



    return totalDepositos - totalRetiros


}